/**
 * Pinia
 *
 * @library
 *
 * https://pinia.vuejs.org/
 */

// Lib imports
import {defineStore} from "pinia";

// Store functionality
import actions from './application/actions'
import state from './application/state'


// Create a new store
const useApplicationStore = defineStore('applicationStore',{
  actions,
  state
});

export default useApplicationStore
